<kendo-formfield>
    <kendo-label [text]="caption | translate">
    </kendo-label>
    <kendo-multiselect #employeesList 
        [ngClass]="{'fx-fill': settings.fxFill}" 
        [data]="employeesList$ | async"
        [textField]="'nameAndSurname'" 
        [valueField]="'id'" 
        [valuePrimitive]="true" 
        [formControl]="control"
        [autoClose]="false" 
        [checkboxes]="true"
        [filterable]="true"
        [readonly]="settings.readonly" 
        [kendoDropDownFilter]="filterSettings"  
        (valueChange)="onChange($event)">
        <ng-template kendoComboBoxItemTemplate let-employee>

            <div fxFill fxLayout="row" class="employee">
                <div fxLayout="column" class="employee-details">
                    <div class="employee-name">{{ employee.name }} - {{ employee.surname }}</div>
                    <div class="employee-position">{{ employee.position }}</div>
                </div>
            </div>
        </ng-template>
    </kendo-multiselect>
</kendo-formfield>
